import React, { useRef, useState } from 'react'

import {
	motion,
	useScroll,
	useTransform,
	useSpring,
} from 'framer-motion/dist/framer-motion'
import { Link } from 'react-router-dom'

import './VagaItem.scss'

export function VagaItem({ data, isLast }) {
	var isSafari =
		navigator.vendor &&
		navigator.vendor.indexOf('Apple') > -1 &&
		navigator.userAgent &&
		navigator.userAgent.indexOf('CriOS') == -1 &&
		navigator.userAgent.indexOf('FxiOS') == -1
	const [hover, setHover] = useState('initial')
	const item = useRef()
	const { scrollYProgress } = useScroll({
		target: item,
		offset: ['1 0.5', '0 0'],
	})
	const lineScale = useSpring(
		useTransform(scrollYProgress, [0, 0.15, 0.5, 0.85, 1], [0, 1, 1, 1, 1]),
		{ bounce: 0.25 }
	)
	const strokeArray = useTransform(
		scrollYProgress,
		[0, 0.2, 0.5, 0.8, 1],
		[0, 1, 1, 1, 1]
	)
	const imageX = useTransform(
		scrollYProgress,
		[0, 0.1, 0.5, 0.9, 1],
		[-15, 0, 0, 0, 0]
	)

	return (
		<motion.li
			ref={item}
			className="v-item"
			initial="initial"
			animate={hover}
		>
			<motion.div className="v-item__content">
				{data.icone ? (
					<motion.figure
						variants={{
							initial: {
								backgroundColor: '#E4296F',
							},
							show: {
								backgroundColor: '#981cf6',
							},
						}}
						style={{ opacity: strokeArray, x: imageX }}
						className="v-item__icon"
					>
						<img alt="Icone da Vaga" src={data.icone.sourceUrl} />
					</motion.figure>
				) : (
					<></>
				)}
				<motion.div
					style={{
						opacity: !isSafari ? strokeArray : 1,
						x: !isSafari ? imageX : 0,
					}}
					className="v-item__description"
				>
					<h3>
						{data.titulo}
						<motion.span
							variants={{
								initial: {
									'--fontColor': '#E4296F',
								},
								show: {
									'--fontColor': '#981cf6',
								},
							}}
						>
							{data.tipo}
						</motion.span>
					</h3>
					<h4>{data.informacoes}</h4>
				</motion.div>
				<Link
					onMouseEnter={() => setHover('show')}
					onMouseLeave={() => setHover('initial')}
					to={data.link ? data.link.url : ''}
					target={data.link ? data.target : ''}
				>
					<svg viewBox="0 0 60 60" fill="none">
						<motion.circle
							cx="30"
							cy="30"
							r="29"
							variants={{
								initial: {
									fill: '#FFFFFF00',
									stroke: '#353535',
								},
								show: {
									fill: '#981cf6FF',
									stroke: '#981cf600',
								},
							}}
							stroke="#353535"
							strokeWidth="2"
							strokeDasharray="1 10"
							style={{
								pathLength: strokeArray,
								opacity: strokeArray,
							}}
						/>
						<motion.path
							d="M21.3692 41L37.6154 24.7538V39.3077H41V19H20.6923V22.3846H35.2462L19 38.6308L21.3692 41Z"
							fill="#353535"
							style={{ opacity: strokeArray }}
							variants={{
								initial: {
									fill: '#353535',
								},
								show: {
									fill: '#FFFFFF',
								},
							}}
						/>
					</svg>
				</Link>
			</motion.div>
			<motion.span
				style={{ scaleX: lineScale }}
				className="v-item__line"
			></motion.span>
		</motion.li>
	)
}
